import { useTranslation } from "react-i18next";
import { useUnfinishedExams } from "src/hooks/useExams";

import DefaultExamTable from "./DefaultExamTable";
import { StyledTableCell } from "./DefaultTable";

const formatDate = (date: string) => {
	const newDate = new Date(date);

	return {
		date: newDate.toLocaleDateString(),
		time: newDate.toLocaleTimeString(),
	};
};

interface UnfinishedExamRow {
	name: string;
	totalQuestions: number;
	progress: number;
	updatedAt: string;
	[key: string]: unknown;
}

interface UnfinishedExamsTableProps {
	searchValue?: string;
	[key: string]: unknown;
}

function UnfinishedExamsTable(props: UnfinishedExamsTableProps) {
	const { t } = useTranslation();
	const headers = [
		{},
		{ key: t("table.exam.unfinished.headers.name") },
		{
			key: t("table.exam.unfinished.headers.countOfQuestions"),
			value: "totalQuestions",
		},
		{ key: t("table.exam.unfinished.headers.progress"), value: "progress" },
		{ key: t("table.exam.unfinished.headers.date"), value: "updatedAt" },
		{ key: t("table.exam.unfinished.headers.actions") },
	];

	const renderRow = (row: UnfinishedExamRow) => {
		const { time, date } = formatDate(row.updatedAt);

		return (
			<>
				<StyledTableCell title={row.name} className="text-left size-16-light">
					{row.name}
				</StyledTableCell>
				<StyledTableCell className="text-center size-16-light">
					{row.totalQuestions}
				</StyledTableCell>
				<StyledTableCell className="text-center size-16-light">
					{row.progress}%
				</StyledTableCell>
				<StyledTableCell
					title={`${date}:${time}`}
					className="text-center size-16-light"
				>
					{date}
				</StyledTableCell>
			</>
		);
	};

	return (
		<DefaultExamTable
			{...props}
			searchValue={props.searchValue}
			headers={headers}
			renderRow={renderRow}
			getItems={useUnfinishedExams}
		/>
	);
}

export default UnfinishedExamsTable;
